module.exports = __webpack_public_path__ + "static/media/FolkSolid-01.cf0ef621.svg";